import { use, useEffect, useState } from "react";
import ClientProfileEditView from "../ClientProfileEditView";
import { CalendarGreyIcon, MailGreyIcon, TelephoneIcon, UserBlackIcon, UserGreyIcon } from "../../../../assets/icons";
import { ClientProfileInfoDTO } from "../../../../models/user/user.response";
import Loader from "../../../shared/Loader";
import { userService } from "../../../../services/userService";
import { useNotification } from "../../../toster-notification/NotificationContext";
import { handleErrorNotification } from "../../../../utils/errorNotificatioMessage";


const ClientProfileInfoTab: React.FC = () => {

    const [isClientProfileEditViewOpen, setIsClientProfileEditViewOpen] = useState(false);

    const [clientProfileInfo, setClientProfileInfo] = useState<ClientProfileInfoDTO | null>(null);
    const [loading, setLoading] = useState<boolean>(false);

    const { notify } = useNotification();


    useEffect(() => {
        fetchClientProfileInfo();
    }, []);


    const fetchClientProfileInfo = async () => {
        setLoading(true);
        try {
            const response = await userService.getClientProfileInfo();
            if (response.data) {
                setClientProfileInfo(response.data);
            } else {
                notify("error", response.message || "Neuspešno učitavanje podataka o profilu.");
            }
        } catch (error: any) {
            notify("error", "Neuspešno učitavanje podataka o profilu.");
            handleErrorNotification(error, notify);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <Loader />;
    }

    if (!clientProfileInfo) {
        return <div>Nema podataka o profilu.</div>;
    }

    return (
        <>
            {isClientProfileEditViewOpen &&
                <ClientProfileEditView
                    onClose={() => {
                        setIsClientProfileEditViewOpen(false)
                        fetchClientProfileInfo();
                    }}
                />
            }

            <div className="admin-settings-box-div">
                <div className="admin-settings-box-header-div">
                    <div className="admin-settings-box-header-info-div">
                        <div className="admin-settings-box-header-info-title-div">
                            <img src={UserBlackIcon} loading="lazy" alt="" className="icon-size-20" />
                            <div className="admin-settings-box-header-info-title">Moj Profil</div>
                        </div>
                        <div className="description-text">Upravljajte svojim podacima</div>
                    </div>
                    <div className="admin-settings-box-header-actions-div">
                        <div className="button-primary grey-bg" onClick={() => setIsClientProfileEditViewOpen(true)}>
                            <div>Izmeni </div>
                        </div>
                    </div>
                </div>
                <div className="div-block-49">
                    <div className="div-block-48">
                        {clientProfileInfo.imageUrl ? (
                            <>
                                <img src={clientProfileInfo.imageUrl + "@lg.webp"} loading="lazy" alt="" className="image-17" />
                                {/* <div className="button-primary">
                                    <div>Izaberi novu skliku</div>
                                </div>
                                <div className="button-primary grey-bg">
                                    <div>Ukloni sliku</div>
                                </div> */}
                            </>
                        ) : (
                            <>
                                <div>
                                    <img src={UserGreyIcon} loading="lazy" alt="" className="image-17" />
                                </div>
                                {/* <div className="button-primary">
                                    <div>Postavi sliku</div>
                                </div> */}
                            </>
                        )}

                    </div>
                    <div className="admin-settings-box-body-div">
                        <div className="div-block-43 grey-bg">
                            <img src={UserGreyIcon} loading="lazy" alt="" className="icon-size-24" />
                            <div className="div-block-44">
                                <div className="description-text">Ime i prezime</div>
                                <div className="text-block-32">{clientProfileInfo.fullName}</div>
                            </div>
                        </div>
                        <div className="div-block-43 grey-bg">
                            <img src={MailGreyIcon} loading="lazy" alt="" className="icon-size-24" />
                            <div className="div-block-44">
                                <div className="description-text">Email</div>
                                <div className="text-block-32">{clientProfileInfo.email}</div>
                            </div>
                        </div>
                        <div className="div-block-43 grey-bg">
                            <img src={CalendarGreyIcon} loading="lazy" alt="" className="icon-size-24" />
                            <div className="div-block-44">
                                <div className="description-text">Član od</div>
                                <div className="text-block-32">{new Date(clientProfileInfo.createdAt).toLocaleDateString('sr-RS')}</div>
                            </div>
                        </div>
                        <div className="div-block-43 grey-bg">
                            <img src={TelephoneIcon} loading="lazy" alt="" className="icon-size-24" />
                            <div className="div-block-44">
                                <div className="description-text">Broj telefina</div>
                                <div className="text-block-32">{clientProfileInfo.phoneNumber}</div>
                            </div>
                        </div>
                        <div className="div-block-43 grey-bg">
                            <img src={CalendarGreyIcon} loading="lazy" alt="" className="icon-size-24" />
                            <div className="div-block-44">
                                <div className="description-text">Datum rođenja</div>
                                <div className="text-block-32">{clientProfileInfo.birthDate ? new Date(clientProfileInfo.birthDate).toLocaleDateString('sr-RS') : "Nije postavljeno"}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ClientProfileInfoTab;